import { QuestionOption } from '@/components/decision-tree/components/SurveyItem/components/Question/components/QuestionOption';
import { QuestionTitle } from '@/components/decision-tree/components/SurveyItem/components/Question/components/QuestionTitle';
import { IDontKnowAnswer } from '@/components/decision-tree/hooks';
import { HStack, useRadioGroup } from '@chakra-ui/react';
import { Box, RadioGroup } from '@cmpsr/components';
import { FC, useEffect, useState } from 'react';
import QuestionOptionCard from './components/question-option-card/question-option-card';
import { SingleChoiceAnswer, SingleChoiceProps } from './types';

export const SingleChoice: FC<SingleChoiceProps> = ({ data, saveAnswer, defaultValue, whyWeAskModalDisclosure }) => {
  const { id, label, options, whyWeAskExplanation, tooltip, description } = data;

  const [answer, setAnswer] = useState<SingleChoiceAnswer>({ type: 'singleChoice', value: '' });
  const handleChange = (nextValue: string) => {
    setAnswer({ type: 'singleChoice', value: nextValue });
    saveAnswer({ type: 'singleChoice', value: nextValue }, true);
  };

  useEffect(() => {
    const value =
      (defaultValue as IDontKnowAnswer)?.type === 'iDontKnow' || !defaultValue
        ? ''
        : (defaultValue as SingleChoiceAnswer).value;

    setAnswer({ type: 'singleChoice', value });
    saveAnswer({ type: 'singleChoice', value });
  }, [id]);

  // We show a different layout if there are only two options,
  const { getRootProps, getRadioProps } = useRadioGroup({
    onChange: handleChange,
  });

  if (options.length === 2) {
    return (
      <Box width="full" maxWidth="450px">
        <QuestionTitle
          description={description}
          tooltip={tooltip}
          question={label}
          whyWeAskExplanation={whyWeAskExplanation}
          whyWeAskModalDisclosure={whyWeAskModalDisclosure}
        />
        <HStack {...getRootProps()} mt={6} display="grid" gridTemplateColumns="1fr 1fr" gap={4}>
          {options.map(({ id, label, description }) => {
            return (
              <QuestionOptionCard
                key={id}
                componentProps={{
                  ...getRadioProps({ id }),
                  value: id,
                  name: label,
                  isChecked: id === answer.value,
                }}
                label={label}
                description={description}
              />
            );
          })}
        </HStack>
      </Box>
    );
  }

  return (
    <Box width="full" maxWidth="450px">
      <QuestionTitle
        description={description}
        tooltip={tooltip}
        question={label}
        whyWeAskExplanation={whyWeAskExplanation}
        whyWeAskModalDisclosure={whyWeAskModalDisclosure}
      />
      <RadioGroup onChange={handleChange} value={answer.value} mt={6}>
        {options.map(({ id, label, description }) => (
          <QuestionOption
            key={`SingleChoice-${id}`}
            componentType="radio"
            componentProps={{
              value: id,
            }}
            label={label}
            description={description}
          />
        ))}
      </RadioGroup>
    </Box>
  );
};
